import {
  PaintBucket,
  Layers,
  Grid3x3,
  DoorOpen,
  Square,
  Wrench,
} from "lucide-react";

const services = [
  {
    icon: PaintBucket,
    title: "Painting",
    body: "Walls, ceilings, trim, doors, prep, patching, priming and clean finish coats.",
  },
  {
    icon: Layers,
    title: "Flooring",
    body: "Vinyl plank, laminate, floor prep, transitions, baseboards and repairs.",
  },
  {
    icon: Grid3x3,
    title: "Tile Work",
    body: "Bathroom tile, backsplashes, tub surrounds, repairs, grout and clean layouts.",
  },
  {
    icon: DoorOpen,
    title: "Trim & Doors",
    body: "Baseboards, casing, door installs, hardware fixes, closet doors and finishing.",
  },
  {
    icon: Square,
    title: "Windows",
    body: "Window trim, drywall returns, insulation around windows, glass and sash updates.",
  },
  {
    icon: Wrench,
    title: "Drywall & Repairs",
    body: "Water damage repairs, hanging, taping, mudding, skim coating, priming and painting.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-brand-bone"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <p className="eyebrow">What we do</p>
            <h2 className="section-title mt-3">
              Interior services built for{" "}
              <span className="italic font-medium">real homes.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-brand-sub leading-relaxed max-w-md">
              Six core services. One detail-focused crew. Whether it's a single
              bathroom or a whole-floor refresh, we keep the job clean, the
              quality high, and the timeline honest.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-brand-line">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group relative p-8 md:p-10 border-r border-b border-brand-line bg-white hover:bg-brand-ink transition-colors duration-300"
              >
                <div className="flex items-center justify-between">
                  <div className="h-11 w-11 border border-brand-line flex items-center justify-center group-hover:border-white/30 group-hover:bg-brand-rust group-hover:border-brand-rust transition-all">
                    <Icon className="h-5 w-5 text-brand-ink group-hover:text-white transition-colors" />
                  </div>
                  <span className="font-display text-xs text-brand-sub group-hover:text-white/50 transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-2xl font-bold text-brand-ink group-hover:text-white transition-colors">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-sub group-hover:text-white/75 transition-colors">
                  {s.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
